import { Api } from "../../Api";

export const getExploreCollectionRecordService = async () => {
  let url = `/collection/get-explore-collection?limit=3`;
  const response = await Api.get(url);
  return response;
};

export const getAIRankingNFTsService = async (limit: number = 10) => {
  let url = `/nft/get-nft-ranking?limit=${limit}`;
  const response = await Api.get(url);
  return response;
};

export const getAIRankingCollectionService = async () => {
  let url = `/collection/get-collection-ranking`;
  const response = await Api.get(url);
  return response;
};

export const searchNFTsAndCollectionsService = async (
  keyword: string,
  limit: number = 10
) => {
  let url = `/collection/search-collection?`;

  if (keyword) {
    url += `search=${keyword}&`;
  }

  if (limit) {
    url += `limit=${limit}&`;
  }

  url = url.endsWith("&") ? url.slice(0, -1) : url;

  const response = await Api.get(url);
  return response;
};

export const searchFilterNFTsAndCollectionsService = async (
  keyword: string,
  limit: number = 10,
  page: number = 1,
  blockchain_network: string = "",
  rank_by: string = "",
  category_id: string,
  eco_category_id: string
) => {
  let url = `/collection/search-collection?`;

  if (keyword) {
    url += `search=${keyword}&`;
  }

  if (limit) {
    url += `limit=${limit}&`;
  }

  if (page) {
    url += `page=${page}&`;
  }

  if (blockchain_network) {
    url += `blockchain_network=${blockchain_network}&`;
  }

  if (rank_by) {
    url += `rank_by=${rank_by}&`;
  }

  if (category_id) {
    url += `category_id=${category_id}&`;
  }

  if (eco_category_id) {
    url += `eco_category_id=${eco_category_id}&`;
  }

  url = url.endsWith("&") ? url.slice(0, -1) : url;

  const response = await Api.get(url);
  return response;
};

export const getTrendingCollectionService = async (
  page: number,
  limit: number = 3,
  duration: string
) => {
  let url = `/collection/get-trending-collection?`;

  if (page) {
    url += `page=${page}&`;
  }

  if (limit) {
    url += `limit=${limit}&`;
  }

  if (duration) {
    url += `time=${duration}&`;
  }

  url = url.endsWith("&") ? url.slice(0, -1) : url;

  const response = await Api.get(url);
  return response;
};
